import {BaseDTO} from '../../../common/models/BaseDTO';
import {NameValueDTO} from '../../../common/models/NameValueDTO';
import {CasePaymentLinkDTO} from './CasePaymentLinkDTO';
import {TransactionPaymentLinkDTO} from "./TransactionPaymentLinkDTO";

export class PaymentDTO extends BaseDTO {
  paymentId: number;
  paymentReference: string;
  bankAccountNumber: string;
  isActive: number;
  paymentExecutionDate: Date;
  paymentCompletionDate: Date;
  transactionPayments: TransactionPaymentLinkDTO[];
  casePayments: CasePaymentLinkDTO[];
  providerPayees: NameValueDTO[];
  beneficiaryPayees: NameValueDTO[];
  paymentType: NameValueDTO;
  amount: number;
  isImmediate: number;
}
